import React from 'react'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    textAlign: 'center',
    marginTop: 20,
    padding: '0px 40px 0px 40px',
    height: 60,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    color: '#19233c',
  },
  subTitle: {
    color: '#19233c',
    textAlign: 'center',
    marginTop: 0,
    padding: '0px 40px',
  },
}))

const Header = (props) => {
  const classes = useStyles()
  const {
    title,
    subTitle,
    regularSubtitle = false,
    customClass,
  } = props

  const subTitleEl = subTitle
    ? regularSubtitle
      ? <span className={classes.subTitle}>{subTitle}</span>
      : <h6 className={classes.subTitle}>{subTitle}</h6>
    : null

  return (
    <div className={`${classes.container} ${customClass || ''}`}>
      <div className={classes.content}>
        <div className={classes.title}>{title}</div>
        {subTitleEl}
      </div>
    </div>
  )
}

export default Header
